export default __webpack_public_path__ + "static/media/fab-logo@2x.94f841f9.png";